import { render, staticRenderFns } from "./new-applicant-data.vue?vue&type=template&id=b82a882e&scoped=true"
import script from "./new-applicant-data.vue?vue&type=script&lang=js"
export * from "./new-applicant-data.vue?vue&type=script&lang=js"
import style0 from "./new-applicant-data.vue?vue&type=style&index=0&id=b82a882e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82a882e",
  null
  
)

export default component.exports